import { atom } from 'jotai/vanilla';
import Cookie from 'js-cookie';
import LOCAL_STORAGE_DATA from '../constants/local-storage-data';
import { hireVueLinkFeatureFlag } from './featureFlag';
import { atomWithStorage } from 'jotai/vanilla/utils';
import { logSourceTrackingParams } from '../utils/source-tracking-logger';

export enum COUNTRIES {
  US = 1,
  CA = 2,
  GB = 3,
  MX = 4,
  IN = 5,
}

const page = {
  [COUNTRIES.US]: 'tutor-application/thank-you',
  [COUNTRIES.CA]: 'en-ca/tutor-application/thank-you',
  [COUNTRIES.GB]: 'tutor-application/thank-you_gb',
  [COUNTRIES.MX]: 'tutor-application/thank-you_mx',
  [COUNTRIES.IN]: 'tutor-application/thank-you',
  default: 'tutor-application/thank-you',
};

const sent_utm_params = atom(false);

const utm_params = atom((get) => {
  const params = get(query_params);
  const cookieParams = get(cookie_params);

  const resolvedSource =
    params.get('rx_source') ??
    cookieParams.get('utm_source') ??
    cookieParams.get('rx_source') ??
    '';

  // Log source tracking parameters for analytics and debugging
  // This helps identify possible duplicate report events for LinkedIn visits
  logSourceTrackingParams(params, cookieParams, resolvedSource);

  return {
    subject: params.get('vtsubject') ?? cookieParams.get('subject') ?? '',
    source: resolvedSource,
    campaign: params.get('rx_campaign') ?? cookieParams.get('utm_campaign') ?? '',
    jobId: params.get('rx_job') ?? '',
  };
});

const query_params = atom(() => {
  return new URLSearchParams(window.location.search);
});

const cookie_params = atom(() => {
  const cookieParams = Cookie.get('OptanonConsent');
  return new URLSearchParams(cookieParams);
});

const application_id = atomWithStorage(LOCAL_STORAGE_DATA.APPLICATION_ID, '');

const is_complete_primitive = atom(false);
const is_complete = atom(
  (get) => get(is_complete_primitive),
  (get, set, complete?: boolean) => {
    const isHireVueLinkEnabled = get(hireVueLinkFeatureFlag);

    if (complete && !isHireVueLinkEnabled) {
      const declared_country = get(country);

      Object.values(LOCAL_STORAGE_DATA).forEach((item) => {
        localStorage.removeItem(item);
      });

      return (window.location.href = `${process.env.VITE_DOMAIN_NAME}/${
        page[declared_country] ?? page.default
      }`);
    }

    if (isHireVueLinkEnabled) {
      set(is_complete_primitive, Boolean(complete));
    }
  },
);

const is_in_review = atom(false);

const country_primitive = atom(1); // United States
const country = atom(
  (get) => get(country_primitive),
  (_get, set, country: number) => {
    set(country_primitive, country);
  },
);

export default {
  application_id,
  is_complete,
  is_in_review,
  country,
  query_params,
  utm_params,
  sent_utm_params,
};
